import type { DocType } from '@eriko/shared-types';
import axios from 'axios';
import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

interface PresignResponse {
  uploadUrl: string;
  /** New canonical id — the Document row id. */
  documentId: string;
  /** Legacy alias (same value as documentId) for one deploy cycle. */
  uploadId: string;
  fileUrl: string;
  fileKey: string;
}

export async function presignUpload(input: {
  fileName: string;
  fileType: string;
  fileSize: number;
  docType?: DocType;
  linkedConversationId?: string;
}): Promise<PresignResponse> {
  const res = await apiClient.post<PresignResponse>(ENDPOINTS.upload.presign, input);
  return res.data;
}

export async function uploadToPresignedUrl(
  uploadUrl: string,
  file: File,
  onProgress?: (percent: number) => void,
): Promise<void> {
  await axios.put(uploadUrl, file, {
    headers: { 'Content-Type': file.type || 'application/octet-stream' },
    onUploadProgress: (e) => {
      if (e.total && onProgress) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    },
  });
}
